import { render, staticRenderFns } from "./CardInformacoes.vue?vue&type=template&id=ad3806a4&scoped=true"
import script from "./CardInformacoes.vue?vue&type=script&lang=js"
export * from "./CardInformacoes.vue?vue&type=script&lang=js"
import style0 from "./CardInformacoes.vue?vue&type=style&index=0&id=ad3806a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3806a4",
  null
  
)

export default component.exports